module.exports = __webpack_public_path__ + "2a5ef13d43c6c081d9f48dd12b5d0daa.png";